/* import __COLOCATED_TEMPLATE__ from './site-header.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './site-header.module.scss';

export default class PaymentLinkSiteHeader extends Component {
  @service currentPractice;
  @service localeManager;

  styles = styles;

  get practiceName() {
    return this.currentPractice.get('fullName');
  }
}
